import axios from "axios";
import URL from "./urlPath";
import { showNotify } from 'vant';
import User from './user'
import qs from 'qs'

const service = axios.create({
  baseURL: URL.baseUrl,
  timeout: 30000, // 请求超时时间,
});
service.interceptors.request.use(
  (config) => {
    if (config.method == 'get' && (!config.url.includes('/User/campusAppLogin'))) {
      config.method = 'post'
      const params = config.params
      if (params != null || params != undefined) {
        const keys = Object.keys(params)
        if (keys.length > 0 && keys.includes('uid')) {
          config.data = qs.stringify(params)
          config.params = {}
        } else {
          let n_params = { ...User.getUTP(), ...params }
          config.data = qs.stringify(n_params)
        }
      }else{
        let n_params = { ...User.getUTP()}
         config.data = qs.stringify(n_params)
      }
    }else if(config.method == 'post'){
        if(config.url.includes('/Upload/File/post')){
           let formData = config.data
           const params = User.getUTP()
           formData.append("uid",params.uid)
           formData.append("token",params.token)
           config.data = formData
           config.params = {}

        }else{
          const utps = qs.stringify(User.getUTP())
          config.data = `${config.data}&${utps}`
          config.params = {}
        }
    }
    if (
      !config.headers["Content-Type"] ||
      config.headers["Content-Type"] == undefined
    ) {
      config.headers["Content-Type"] =
        "application/x-www-form-urlencoded;charset=utf-8";
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const status_code = response.status;
    // console.log("request_code:",status_code,response.data)
    if (status_code == 200) {
      let {
        code,
        result: { data, list, total },
      } = response.data;
      let result = null;
      if (data == undefined && list == undefined) {
        result = response.data.result;
      }
      if (list != undefined && total != undefined) {
        const new_list = {
          total: total,
          list: JSON.parse(JSON.stringify(list)),
        };
        list = new_list;

      }
      // console.log("请求结果:", code, data, list,result);
      if (code == 1) {
        return Promise.resolve(data || list || result);
      } else if (code == -98) {
        // showNotify({ type: 'danger', message: msg });
        User.loginOut()
        const originDomain = window.origin
        window.location.replace(originDomain)
      } else {
        const msg = response.data.msg ? response.data.msg : "请求错误";
        showNotify({ type: 'danger', message: msg });
      }
    } else {

    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
